import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/cc1.png'
import _imports_1 from '../assets/cc2.png'
import _imports_2 from '../assets/tutorial.png'
import _imports_3 from '../assets/cc3.png'
import _imports_4 from '../assets/windows.png'
import _imports_5 from '../assets/updata.png'
import _imports_6 from '../assets/iosewm.png'
import _imports_7 from '../assets/ios.png'
import _imports_8 from '../assets/web.png'
import _imports_9 from '../assets/open.png'
import _imports_10 from '../assets/yun.png'
import _imports_11 from '../assets/guanbi.png'
import _imports_12 from '../assets/register_ewm.png'


const _withScopeId = n => (_pushScopeId("data-v-7512fc62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","overflow-x":"hidden"} }
const _hoisted_2 = { class: "introduction" }
const _hoisted_3 = { class: "card-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-f p-r" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "left",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "right p-a",
    src: _imports_1
  })
], -1))
const _hoisted_5 = { class: "d-f introduction_text j-b mt-20" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"opacity":"0"},
  src: _imports_3
}, null, -1))
const _hoisted_7 = { class: "download" }
const _hoisted_8 = { class: "card-wrap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c33 f20 f-w" }, "客户端下载列表", -1))
const _hoisted_10 = { class: "download_list" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"download_con\" data-v-7512fc62><div class=\"d-f\" data-v-7512fc62><img class=\"download_img\" src=\"" + _imports_4 + "\" alt=\"\" data-v-7512fc62><div class=\"introductions\" data-v-7512fc62><div data-v-7512fc62>Windows</div><div data-v-7512fc62>win7以上版本，支持32位/64位</div></div></div><a href=\"https://desk.ctyun.cn/desktop/software/clientsoftware/download/98608b8c387dfeaf48698f514e3c657f\" data-v-7512fc62><img class=\"download_up\" src=\"" + _imports_5 + "\" alt=\"\" data-v-7512fc62></a></div>", 1)
const _hoisted_12 = { class: "download_con" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-f" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "download_img",
    src: _imports_6,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "introductions" }, [
    /*#__PURE__*/_createElementVNode("div", null, "移动端"),
    /*#__PURE__*/_createElementVNode("div", null, "使用ios/Android")
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "",
  selected: ""
}, "选择下载", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "h5-iphone",
  value: "https://apps.apple.com/cn/app/id1454784442"
}, "iOS 下载", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  class: "h5-android",
  value: "https://desk.ctyun.cn/desktop/software/clientsoftware/download/ae4b7b316f2162d75a9fb76f340515f8"
}, "Android 下载", -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"download_con\" data-v-7512fc62><div class=\"d-f\" data-v-7512fc62><img class=\"download_img\" src=\"" + _imports_7 + "\" alt=\"\" data-v-7512fc62><div class=\"introductions\" data-v-7512fc62><div data-v-7512fc62>Mac</div><div data-v-7512fc62>支持macOS 10.14及以上版本</div></div></div><a href=\"https://desk.ctyun.cn/desktop/software/clientsoftware/download/72aff953171791285acee2093d94c2b9\" data-v-7512fc62><img class=\"download_up\" src=\"" + _imports_5 + "\" alt=\"\" data-v-7512fc62></a></div><div class=\"download_con\" data-v-7512fc62><div class=\"d-f\" data-v-7512fc62><img class=\"download_img\" src=\"" + _imports_8 + "\" alt=\"\" data-v-7512fc62><div class=\"introductions\" data-v-7512fc62><div data-v-7512fc62>Web客户端</div><div data-v-7512fc62>访问地址:https://pc.ctyun.cn推荐使用Chrome70+版本以上讯问</div></div></div><a target=\"_blank\" href=\"https://pc.ctyun.cn/\" data-v-7512fc62><img class=\"download_up\" src=\"" + _imports_9 + "\" alt=\"\" data-v-7512fc62></a></div>", 2)
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "configuration" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-wrap" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "c33 f20 f-w" }, "云电脑适配终端终端适配列表"),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_10,
      alt: ""
    })
  ])
], -1))
const _hoisted_21 = {
  key: 0,
  class: "moble"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  id: "my-video",
  class: "video p-a",
  controls: ""
}, [
  /*#__PURE__*/_createElementVNode("source", {
    src: "https://exam.xinxikaoshi.com/exam/profile/upload/2025/02/11/CloudDesktopOperation_20250211095053A003.mp4",
    type: "video/mp4"
  })
], -1))
const _hoisted_23 = { class: "register_ewm p-f" }
const _hoisted_24 = { class: "p-r" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "ewm",
  src: _imports_12,
  alt: ""
}, null, -1))

import top from "./top.vue";
  import bottom from "./bottom.vue";
    import { ref, onMounted,onUnmounted,nextTick } from "vue";
    import {lastVersionReleases} from "@/axios/index";
    import router from "@/router";
    import { useRoute } from "vue-router";
    
export default /*#__PURE__*/_defineComponent({
  __name: 'cc',
  setup(__props) {

  const video= ref(false)
    const register_ewm= ref(false)
    const close = () => {
        video.value = !video.value
    }
    const handleChange = (event) => {
        window.location.href = event.target.value;
    };
    const support = (path,index) => {
        router.push({
            path: "./support",
            query: {
            },
        });
    };
    const releasess = ref();
    const releasess_ = ref();
    const lastVersionReleasess = async () => {
        const { data }: any = await lastVersionReleases({});
        if (data.code == 200) {
            releasess.value = data.data.url
            releasess_.value =data.data.url2
        };
    };
    onMounted(() => {
        lastVersionReleasess();
    //   window.addEventListener('resize', handleResize);
    //   nextTick(() => {
    //     document.oncontextmenu = new Function("event.returnValue=false");
    //     document.onselectstart = new Function("event.returnValue=false");
    //     document.addEventListener("keydown", function (e) {
    //       if (e.key == "F12") {
    //         e.preventDefault(); // 如果按下键F12,阻止事件
    //       }
    //     });
    //   })
    });
  onUnmounted(() => {
  });
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(top, {
      releasess: releasess.value,
      releasess_: releasess_.value
    }, null, 8, ["releasess", "releasess_"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              onClick: close,
              src: _imports_2
            }),
            _createElementVNode("img", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (register_ewm.value = true)),
              src: _imports_3
            }),
            _hoisted_6
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("select", {
                class: "btn select",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (handleChange($event)))
              }, _hoisted_17, 32)
            ]),
            _hoisted_18
          ])
        ])
      ]),
      _hoisted_20,
      (video.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", { class: "p-r" }, [
              _createElementVNode("img", {
                onClick: close,
                class: "p-a",
                src: _imports_11,
                alt: ""
              }),
              _hoisted_22
            ])
          ]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("img", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (register_ewm.value = false)),
            class: "p-a",
            src: _imports_11,
            alt: ""
          })
        ])
      ], 512), [
        [_vShow, register_ewm.value]
      ])
    ]),
    _createVNode(bottom, {
      releasess: releasess.value,
      releasess_: releasess_.value
    }, null, 8, ["releasess", "releasess_"])
  ]))
}
}

})